import types from '../../config/types.js'
import MockServer from './MockServer.js'
import IntercomService from 'Services/IntercomService.js'
import ServiceData from 'Mixins/ServiceData.js'

export default {
  mixins: [MockServer, ServiceData],
  data() {
    return {
      addressList: [this.getBlankAddress()],
      intercomService: IntercomService,
      isNextLoading: false,
    }
  },
  computed: {
    actions() {
      return {
        default: [
          {
            id: 2,
            type: types.actions.button,
            attr: {
              type: 'secondary',
              label: 'Добавить дом',
              disabled: !this.isAddNewAvailable,
              icon: 'plus-outlined',
              handler: () => this.addAddress(),
            },
          },
          {
            id: 4,
            type: types.actions.button,
            attr: {
              type: 'primary',
              label: 'Следующий шаг',
              disabled:
                this.addressListFilledLength === 0 || this.isNextLoading,
              loading: this.isNextLoading,
              handler: () => this.toNextStep(),
            },
          },
        ],
      }
    },
    formList() {
      return [
        {
          id: 'address',
          label: 'Выберите дом',
          required: true,
          type: types.components.select,
          width: 7,
          attr: {
            placeholder: 'Выберите дом',
            options: this.propertyListOptions,
          },
        },
        {
          id: 'server',
          label: 'Выберите сервер',
          required: true,
          type: types.components.select,
          width: 5,
          attr: {
            placeholder: 'Выбрать',
            options: this.serverListOptions,
            // options: [],     // Если не будет опций - покажет кнокку "Добавить сервер" (ниже)
          },
          nooptions: {
            label: 'Добавить сервер',
            icon: 'plus-outlined',
            handler: () => this.onAddServer(),
          },
        },
      ]
    },
    addressListFilledLength() {
      return this.addressList.reduce((acc, item) => {
        const addr = item.form.address
        const serv = item.form.server
        const file = item.file

        if (!addr || !serv || !addr.length || !serv.length || !file) return acc

        ++acc
        return acc
      }, 0)
    },
    isAddNewAvailable() {
      return this.addressList.length === this.addressListFilledLength
    },
  },
  methods: {
    getBlankAddress() {
      return {
        id: Math.random(),
        form: {
          address: [],
          server: [],
        },
        file: null,
      }
    },
    addAddress() {
      this.addressList.push(this.getBlankAddress())
    },
    removeAddress(id) {
      this.addressList = this.addressList.filter(item => item.id !== id)
    },
    getPreparedAdressData() {
      let preparedAddressData = {
        organization_id: this.currentOrganizationId,
        configs: [],
      }

      this.addressList.forEach(address => {
        preparedAddressData.configs.push({
          property_id: address.form.address || null,
          sip_server_id: address.form.server || null,
          contacts_file: address.file,
        })
      })

      return preparedAddressData
    },
    toNextStep() {
      this.isNextLoading = true
      this.intercomService
        .addIntercom(this.getPreparedAdressData())
        .then(response => {
          this.$store.dispatch(
            'setTempIntercomIds',
            response.data.sip_server_contact_config_ids || []
          )
          this.$router.push({ name: 'Contacts' })
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.isNextLoading = false
        })
    },
  },
  mounted() {
    if (this.serverList.length === 0) {
      this.getServers({
        organizationId: this.currentOrganizationId,
      })
    }

    if (this.propertyList.length === 0) {
      this.getProperties({
        organizationId: this.currentOrganizationId,
      })
    }
  },
}
